import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MicrosoftAzureIntegration from "../MicrosoftAzure/MicrosoftAzure";

const MicrosoftAzureCloudIntegration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  return (
    <MicrosoftAzureIntegration
      integrationName="azure"
      guideMode={guideMode}
    ></MicrosoftAzureIntegration>
  );
};

export default MicrosoftAzureCloudIntegration;
